import { Component, Input, Output, EventEmitter } from '@angular/core';
import { AntragComponent } from '../antrag/antrag.component';
import { ZusammenfassungService } from '../../service/zusammenfassung.service';
import { EnumService } from '../../service/enum.service';
import { DataService } from '../../service/data.service';

@Component({
  selector: 'app-zusammenfassung',
  templateUrl: './zusammenfassung.component.html',
  styleUrls: ['./zusammenfassung.component.scss']
})
export class ZusammenfassungComponent {

  @Input()
  antragComponent: AntragComponent;

  @Input()
  expertMode: boolean;

  @Output()
  korrekturEvent = new EventEmitter();

  constructor(public zusammenfassungService: ZusammenfassungService, public enumService: EnumService, public dataService: DataService) { }

  isNaN(date): boolean {
    return isNaN(date);
  }

  getHauptfaelligkeitString(tag: string, monat: string): string {
    return ('0' + tag).slice(-2) + '.' + ('0' + monat).slice(-2) + '.';
  }
}
